

import styled from "styled-components";





const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 20px 0px;
`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 15px;
`;



const Button2 = styled.button`
  width: 250px;
  padding: 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  background-color: ${(props) => (props.ativo ? '#fff' : '#E5F7EE')};
  color: ${(props) => (props.ativo ? '#008000' : '#008000')};
  border: 2px solid #e5f7ee;
  transition: all 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`;



const Grid = ({ onAberto, onAtendimento, onFinalizado, onCancelado, onTotal, quantidadeChamado, tipoAcessoModulo8, painelVisivel }) => {



  const getTotalPorSituacao = (codSituacao) => {
    const item = quantidadeChamado.find(q => q.COD_SITUACAO == codSituacao);
    return item ? item.QUANTIDADE : 0;
  };


  const isActive = (painel) => painelVisivel === painel;


  return (
    <Container>
      <Div>
        <Button2
          width="10%"
          onClick={onAberto}
          ativo={isActive('ABERTO')} // ← Aqui passa a flag
        >
          Abertos
          {(tipoAcessoModulo8 === 'G') && (
            <h2>{getTotalPorSituacao('AB')}</h2>
          )}
        </Button2>

        <Button2 width="10%" onClick={onAtendimento} ativo={isActive('ATENDIMENTO')}>
          Atendimento
          {(tipoAcessoModulo8 === 'G') && (
            <h2>{getTotalPorSituacao('AT')}</h2>
          )}
        </Button2>

        <Button2 width="10%" onClick={onFinalizado} ativo={isActive('FINALIZADO')}>
          Finalizado
          {(tipoAcessoModulo8 === 'G') && (
            <h2>{getTotalPorSituacao('FI')}</h2>
          )}
        </Button2>

        <Button2 width="10%" onClick={onCancelado} ativo={isActive('CANCELADO')}>
          Cancelados
          {(tipoAcessoModulo8 === 'G') && (
            <h2>{getTotalPorSituacao('CA')}</h2>
          )}
        </Button2>

        <Button2 width="10%" onClick={onTotal} ativo={isActive('TOTAL')}>
          Total
          {(tipoAcessoModulo8 === 'G') && (
            <h2>{getTotalPorSituacao('Total')}</h2>
          )}
        </Button2>

      </Div>
    </Container>
  );
};


export default Grid;
